import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

import { AccountFacade } from '@mode/accounts/contract';
import { DatasourceFacade, WorkspaceCollectionFacade } from '@mode/accounts/domain';
import { MetaTags, MetaTagsService } from '@mode/shared/util-js';

@Injectable()
export class NavMenuService {
  private _navOpen$ = new BehaviorSubject<boolean>(false);
  private _renderer: Renderer2;

  constructor(
    rendererFactory: RendererFactory2,
    private _meta: MetaTagsService,
    private _accountFacade: AccountFacade,
    private _datasourceFacade: DatasourceFacade,
    private _workspaceCollectionFacade: WorkspaceCollectionFacade
  ) {
    this._renderer = rendererFactory.createRenderer(null, null);
  }

  open(options?: { inline?: boolean }): void {
    this.loadData();
    this._renderer.addClass(document.body, options?.inline ? 'sidebar-scroll' : 'sidebar-open');
    this._navOpen$.next(true);
  }

  close(): void {
    this._renderer.removeClass(document.body, 'sidebar-scroll');
    this._renderer.removeClass(document.body, 'sidebar-open');
    this._navOpen$.next(false);
  }

  navState(): Observable<boolean> {
    return this._navOpen$.pipe(distinctUntilChanged());
  }

  loadData(): void {
    this._workspaceCollectionFacade.loadCollections();
    this._datasourceFacade.loadDatasources();
    const selectedOrg = this._meta.getTag(MetaTags.OwnerUsername);
    const username = this._meta.getTag(MetaTags.CurrentUsername);
    if (selectedOrg && username) {
      this._accountFacade.loadCurrentOrg(selectedOrg);
      this._accountFacade.loadCurrentUser(username);
    }
  }
}
